var VariableService = /** @class */ (function () {
    function VariableService(api) {
        var _this = this;
        this.fetchVariables = function (app) { return _this.API.get("/variable/".concat(app)); };
        this.createVariable = function (variable) { return _this.API.post('/variable', variable); };
        this.updateVariable = function (variable) {
            return _this.API.patch("/variable/".concat(variable === null || variable === void 0 ? void 0 : variable.app, "/").concat(variable === null || variable === void 0 ? void 0 : variable.id), variable);
        };
        this.deleteVariable = function (app, variable) {
            return _this.API.delete("/variable/".concat(app, "/").concat(variable));
        };
        this.API = api;
    }
    return VariableService;
}());
export { VariableService };
